import React from 'react';
import dataunfoldLogo from '../../images/logotransparent.png';
import { Box, Typography } from '@mui/material';

// Theme colors - matching Sidebar
const primaryColor = '#5757b0';

const TimeEventLoading = React.memo(() => {
  return (
    <Box 
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '120px',
        p: 3,
        background: 'transparent'
      }}
    >
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2
        }}
      >
        {/* Simple loading ring with logo */}
        <Box sx={{ 
          position: 'relative', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' 
        }}>
          {/* Rotating ring */}
          <Box sx={{
            position: 'absolute',
            width: 60,
            height: 60,
            borderRadius: '50%',
            border: '2px solid transparent',
            borderTop: '2px solid #5757b0',
            animation: 'spin 2s linear infinite',
            '@keyframes spin': {
              '0%': { transform: 'rotate(0deg)' },
              '100%': { transform: 'rotate(360deg)' }
            }
          }} />
          
          {/* Logo */}
          <img 
            src={dataunfoldLogo} 
            alt="Loading..." 
            style={{ 
              width: '35px', 
              height: '35px'
            }} 
          />
        </Box>
        
        {/* Loading text */}
        <Typography 
          variant="body2" 
          sx={{ 
            color: primaryColor,
            animation: 'fade 2s infinite ease-in-out',
            '@keyframes fade': {
              '0%, 100%': { opacity: 0.6 },
              '50%': { opacity: 1 }
            }
          }}
        >
          Loading event...
        </Typography>
      </Box>
    </Box>
  );
});

export default TimeEventLoading;
